import type { JSX, ReactNode } from 'react';
import { Menu } from '@mantine/core';

/**
 * A submenu inside a menu (Mantine 7 has none): an item that opens a second
 * menu to its right on hover or click. Rendered inside the parent's dropdown,
 * not in a portal, so a click in it does not count as "outside" and close
 * the parent before the click arrives.
 *
 * The item belongs to the submenu's own Menu, which forgets its hover state
 * when it opens; `pst-submenu-target` (app.css) keeps it marked while open.
 * A click in the submenu closes only the submenu: the parent closes through
 * the `close` its entries call, so a parent menu must be controlled.
 */
export function SubMenu({ label, children, width = 230 }: { label: string; children: ReactNode; width?: number }): JSX.Element {
  return (
    <Menu trigger="click-hover" position="right-start" offset={2} withinPortal={false} openDelay={60} closeDelay={200} width={width} loop>
      <Menu.Target>
        <Menu.Item className="pst-submenu-target" closeMenuOnClick={false} rightSection={<span aria-hidden>▸</span>}>{label}</Menu.Item>
      </Menu.Target>
      <Menu.Dropdown>{children}</Menu.Dropdown>
    </Menu>
  );
}
